module.exports = __webpack_public_path__ + "static/media/banner3.d1814cdb.png";